export const PAYMENT_STATUS_COLORS: Record<string, string> = {
  captured: 'green',
  awaiting: 'orange',
  not_paid: 'default',
  refunded: 'blue',
};

export const getPaymentStatusLabel = (status: string, t: (key: string) => string): string => {
  const map: Record<string, string> = {
    captured: t('orders.paymentCaptured'),
    awaiting: t('orders.paymentAwaiting'),
    not_paid: t('orders.paymentNotPaid'),
    refunded: t('orders.paymentRefunded'),
  };
  return map[status] || status;
};

export const FULFILLMENT_STATUS_COLORS: Record<string, string> = {
  fulfilled: 'green',
  not_fulfilled: 'default',
  shipped: 'blue',
};

export const getFulfillmentStatusLabel = (status: string, t: (key: string) => string): string => {
  const map: Record<string, string> = {
    fulfilled: t('orders.fulfilled'),
    not_fulfilled: t('orders.notFulfilled'),
    shipped: t('orders.shipped'),
  };
  return map[status] || status;
};
